module.exports = __webpack_public_path__ + "img/quotes.ae4c2ca.png";